import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import React, { useContext } from 'react'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import { useWindowSize } from '../../../hooks/useWindowSize'
import buildStyles from './style'
import AppContext from '../../../app/context'

export interface EntityInfoProps {
  title: string
  subtitle: string
  isOpen: boolean
  onClose: () => void
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined
  style?: React.CSSProperties | undefined
  fullscreen?: boolean
  fullWidth?: boolean
}

const EntityInfo = ({
  title,
  subtitle,
  isOpen,
  onClose,
  maxWidth,
  style,
  fullscreen,
  fullWidth,
}: EntityInfoProps) => {
  const { state } = useContext(AppContext)
  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    isMobile: isMobile,
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <>
      <Dialog
        fullScreen={fullscreen}
        open={isOpen}
        onClose={onClose}
        maxWidth={maxWidth}
        style={style}
        fullWidth={fullWidth}
        PaperProps={{ style: { borderRadius: 25 } }}
      >
        <DialogTitle>
          <div className={styles.title}>{title}</div>
        </DialogTitle>
        <DialogContent className={styles.subtitleWrapper}>
          <div className={styles.subtitle}>{subtitle}</div>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', padding: '30px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            style={{
              borderRadius: '15px',
              width: '50%',
            }}
            className={styles.button}
          >
            <div className={styles.textButton}>ZAMKNIJ</div>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EntityInfo
